$(function() {
  $('.dropdown').on('hide.bs.dropdown', function(e) {
    if(window.preventHidingDropdowns) {
      window.preventHidingDropdowns = false;

      return false;
    }
  });
});